import React from "react";

export default function Footer() {
  return (
    <div className="Footer">
      This app project is open-source on{" "}
      <a href="https://github.com/marnicodes/weather-react-app">Github</a> by{" "}
      <a href="https://peaceful-wiles-ea9b0d.netlify.app/">Marni Ali</a>
    </div>
  );
}
